import { push } from 'react-router-redux';
import moment from 'moment';
import jwtDecode from 'jwt-decode';
import { toastr } from 'react-redux-toastr';
import { loginUserFailure } from '../actions/auth';
import valuesList from '../constants/values';

export function createConstants(...constants) {
  return constants.reduce((acc, constant) => {
    const acc2 = acc;
    acc2[constant] = constant;
    return acc2;
  }, {});
}

export const createReducer = (initialState, reducerMap) => (state = initialState, action) => {
  const reducer = reducerMap[action.type];

  return reducer ? reducer(state, action.payload) : state;
};

export const checkHttpStatus = response => {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  const error = new Error(response.statusText);
  error.response = response;

  throw error;
};

export const parseJSON = response => response.json();

export const fetchCentralApi = ({ path, method, token, body, dispatch, cb, fb, contentType }) => {
  const headers = {
    Accept: 'application/json',
    'Content-Type': contentType || 'application/json',
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return fetch(process.env.REACT_APP_SERVICES_BACKEND_URL + path, {
    method,
    headers,
    body,
  })
    .then(checkHttpStatus)
    .then(parseJSON)
    .then(response => {
      dispatch(cb(response));
    })
    .catch(error => {
      const { response } = error;

      if (response) {
        response.json().then(err => {
          const { message } = err;

          if (message) {
            toastr.error(message);
          }

          if (response.status === 401) {
            dispatch(loginUserFailure());
            dispatch(push('/login'));
          } else {
            dispatch(fb());
          }
        });
      }
    });
};

export const fetchApi = ({ path, method, token, body, dispatch, cb, fb, contentType }) => {
  const headers = {
    Accept: 'application/json',
    'Content-Type': contentType || 'application/json',
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return fetch(process.env.REACT_APP_BACKEND_URL + path, {
    method,
    headers,
    body,
  })
    .then(checkHttpStatus)
    .then(parseJSON)
    .then(response => {
      dispatch(cb(response.data));
    })
    .catch(error => {
      const { response } = error;

      if (response) {
        response.json().then(err => {
          const { message } = err;

          if (message) {
            toastr.error(message);
          }

          if (response.status === 401) {
            dispatch(loginUserFailure());
            dispatch(push('/login'));
          } else {
            dispatch(fb());
          }
        });
      }
    });
};

export function onInputChange() {
  return function returnOnInputChange(path, isCheckbox) {
    return e => {
      let value;
      const { target } = e;

      if (moment.isMoment(e)) {
        value = e.format('hh:mm A');
      } else if (target.multiple) {
        value = [...target.options].filter(o => o.selected).map(o => o.value);
      } else if (isCheckbox) {
        value = target.checked;
      } else {
        value = target.value;
      }

      const pathArr = path.split('.');

      const change = {};

      if (pathArr.length === 3) {
        change[pathArr[0]] = this.state[pathArr[0]];

        change[pathArr[0]][pathArr[1]] = this.state[pathArr[0]][pathArr[1]];

        change[pathArr[0]][pathArr[1]][pathArr[2]] = value;
      } else if (pathArr.length === 2) {
        change[pathArr[0]] = this.state[pathArr[0]];

        change[pathArr[0]][pathArr[1]] = value;
      } else if (pathArr.length === 1) {
        change[pathArr[0]] = value;
      }

      this.setState(change);
    };
  };
}

export const capitalizeFirstLetter = string => string.charAt(0).toUpperCase() + string.slice(1);

export const formatErrorScheme = (message, path) => ({
  message,
  path,
});

export const isIE = () =>
  !!(
    window.navigator.userAgent.indexOf('MSIE ') > 0 ||
    !!navigator.userAgent.match(/Trident.*rv:11\./)
  );

export const isTokenValid = token => {
  if (token) {
    const decoded = jwtDecode(token);

    if (decoded.exp > new Date().getTime() / 1000) {
      return true;
    }
  }

  return false;
};

export const documentOffsetTop = elem =>
  elem.offsetTop + (elem.offsetParent ? documentOffsetTop(elem.offsetParent) : 0);

export const getEnumLong = (category, value) => {
  const nation = valuesList[category].find(n => n.value === value);
  return nation ? nation.name : '';
};



// WEBPACK FOOTER //
// ./src/utils/helpers.js